import { select, put, fork, cancel, delay } from 'redux-saga/effects'
import { error, play } from '../actions'
import { REQUEST_TIMEOUT, SET_DEMO_INDEX, GAME_ACTIONS, SET_WAITING_FOR_CONNECTION } from '../constants'
import AbortController from 'abort-controller'

/**
 * Saga that has a 30 second delay, and will act as a timeout
 * and will dispatch an error message, and abort current fetch, if executed fully.
 * Will show a waiting for connection screen after 5 seconds.
 * @param {AbortController} controller - The controller which should be aborted, at the end of the timeout.
 */
function* onRequestTimeout(controller) {
  yield delay(5000)
  yield put({ type: SET_WAITING_FOR_CONNECTION, show: true })
  yield delay(25000)
  yield put({ type: REQUEST_TIMEOUT })

  console.log('[Connection] - Request Timed out')

  controller.abort()
  yield put(error({ errorCode: 404, errorMessage: 'Request Timed out' }))
}

/**
 * request that will send a POST request to the server.
 * @param {string} url - The endpoint of the POST request.
 * @param {object} params - Parameters for the request.
 * @returns {*}
 */
export default function* request(url, params = {}) {
  // Create a controller instance, to be able to abort a fetch.
  const controller = new AbortController()
  const signal = controller.signal

  const timedOutTimer = yield fork(onRequestTimeout, controller)
  let parameter = params

  let response = null
  const { demomode } = yield select(state => state.session)
  const { serverCheat, demo, playing, demoIndex } = yield select(state => state.base)
  const { fgo } = yield select(state => state.session)

  if (playing) {
    if (serverCheat) {
      parameter = { ...params, forcedOutcome: serverCheat }
    } else if (demomode && params && params.ga === GAME_ACTIONS.SPIN) {
      if (demo.length) {
        parameter = { ...params, forcedOutcome: demo[demoIndex] }
        const nextIndex = demoIndex > demo.length - 2 ? 0 : demoIndex + 1
        yield put({ type: SET_DEMO_INDEX, index: nextIndex })
      } else {
        console.warn("[Warning] - demomode is set to true, but demo-cheats has not been added to the game!")
      }
    } else if (fgo) {
      parameter = { ...params, forcedOutcome: fgo }
    }
  }

  try {
    response = yield fetch(
      `${url}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(parameter),
        signal,
      }).then(res => res.json())

    yield put({ type: SET_WAITING_FOR_CONNECTION, show: false })
    yield cancel(timedOutTimer)

  } catch (e) {
    console.log('[Connection] - request failed!', e)

    yield put({ type: SET_WAITING_FOR_CONNECTION, show: false })
    yield put(error({ errorCode: 400, errorMessage: 'Request failed' }))
    yield cancel(timedOutTimer)
  }

  if (response && response.errorCode) {
    yield put(error(response))
  }

  return response
}
